import React, { useState } from "react";
import { BsArrowLeftCircleFill, BsArrowRightCircleFill } from "react-icons/bs";
import "../css/ImageSlider.css";

export const ImageSlider = ({ data = [] }) => {
  const [slide, setSlide] = useState(0);

  const nextSlide = () => {
    setSlide((slide + 1) % data.length); // Use modulo to loop back to beginning
  };

  const prevSlide = () => {
    setSlide((slide - 1 + data.length) % data.length); // Handle negative indices correctly
  };

  return (
    
    <div className="carousel-small-slider">
      {
        data.length==0 && (
          <p style={{fontSize:"50px",backgroundColor:"black",color:"white",padding:"80px",borderRadius:"70px",textAlign:"center"}}>No Images</p>
        )
      }
      <BsArrowLeftCircleFill onClick={prevSlide} className="arrow arrow-left" />
      {data.map((item, idx) => (
        <img
          src={item}
          alt={`slide-${idx}`}
          key={idx}
          className={slide === idx ? "slide" : "slide slide-hidden"}
        />
      ))}
      <BsArrowRightCircleFill onClick={nextSlide} className="arrow arrow-right" />
      <span className="indicators">
        {data.map((_, idx) => (
          <button
            key={idx}
            className={slide === idx ? "indicator" : "indicator indicator-inactive"}
            onClick={() => setSlide(idx)}
          ></button>
        ))}
      </span>
    </div>
  );
};



